module.exports = __webpack_public_path__ + "img/11.408134e6.jpg";